/*
 * @Description: 注册全局指令
 * @version:
 * @Author: knight
 * @Date: 2021-11-04 17:35:34
 * @LastEditors: knight
 * @LastEditTime: 2022-02-08 17:31:59
 */
const Vue = require('vue');
const _ = require('lodash');
import router from '../router/index'
// 图片懒加载
// console.log(router)
const LazyLoad = {
  // 指令是具有一组生命周期的钩子：
  // 在绑定元素的 attribute 或事件监听器被应用之前调用
  mounted(el, binding) {
    const defaultSrc =
      'https://xlhz.oss-cn-hangzhou.aliyuncs.com/xlhz-admin/assets/images/lazy-img.png';
    LazyLoad.init(el, binding.value, defaultSrc);
    // 兼容处理
    if ('IntersectionObserver' in window) {
      LazyLoad.observe(el);
    } else {
      LazyLoad.listenerScroll(el);
    }
  },
  // 初始化
  init(el, val, def) {
    // data-src 储存真实src
    el.setAttribute('data-src', val);
    // 设置src为loading图
    el.setAttribute('src', def);
    LazyLoad.load(el);
  },
  // 利用IntersectionObserver监听el
  observe(el) {
    const io = new IntersectionObserver(entries => {
      const realSrc = el.dataset.src;
      if (entries[0].isIntersecting) {
        if (realSrc) {
          el.src = realSrc;
          el.removeAttribute('data-src');
        }
      }
    });
    io.observe(el);
  },
  // 监听scroll事件
  listenerScroll(el) {
    const handler = _.throttle(LazyLoad.load, 300);
    LazyLoad.load(el);
    window.addEventListener('scroll', () => {
      handler();
    });
  },
  // 加载真实图片
  load(el) {
    const windowHeight = document.documentElement.clientHeight;
    const elTop = el.getBoundingClientRect().top;
    const elBtm = el.getBoundingClientRect().bottom;
    const realSrc = el.dataset.src;
    if (elTop - windowHeight < 0 && elBtm > 0) {
      if (realSrc) {
        el.src = realSrc;
        el.removeAttribute('data-src');
      }
    }
  },
  // 节流
};

Vue.directive('LazyLoad', LazyLoad);

Vue.directive('autoTextarea', {
  inserted: function (elem) {
    const extra = extra || 0;
    const maxHeight = elem.maxHeight;
    var isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window;
    var isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera');
    var addEvent = function (type, callback) {
      elem.addEventListener
        ? elem.addEventListener(type, callback, false)
        : elem.attachEvent('on' + type, callback);
    };
    var getStyle = elem.currentStyle
      ? function (name) {
          var val = elem.currentStyle[name];

          if (name === 'height' && val.search(/px/i) !== 1) {
            var rect = elem.getBoundingClientRect();
            return (
              rect.bottom -
              rect.top -
              parseFloat(getStyle('paddingTop')) -
              parseFloat(getStyle('paddingBottom')) +
              'px'
            );
          }

          return val;
        }
      : function (name) {
          return getComputedStyle(elem, null)[name];
        };
    var minHeight = parseFloat(getStyle('height'));

    elem.style.resize = 'none';

    var change = function () {
      var scrollTop;
      var height;
      var padding = 0;
      var style = elem.style;

      if (elem._length === elem.value.length) return;
      elem._length = elem.value.length;

      if (!isFirefox && !isOpera) {
        padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'));
      }
      scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

      elem.style.height = minHeight + 'px';
      if (elem.scrollHeight > minHeight) {
        if (maxHeight && elem.scrollHeight > maxHeight) {
          height = maxHeight - padding;
          style.overflowY = 'auto';
        } else {
          height = elem.scrollHeight;
          style.overflowY = 'hidden';
        }
        style.height = height + extra + 'px';
        scrollTop += parseInt(style.height) - elem.currHeight;
        document.body.scrollTop = scrollTop;
        document.documentElement.scrollTop = scrollTop;
        elem.currHeight = parseInt(style.height);
      }
    };

    addEvent('propertychange', change);
    addEvent('input', change);
    addEvent('focus', change);
    change();
  },
});

Vue.directive('back', {
  inserted: function (elem) {
    elem.onclick = function () {
      if (window.history.length <= 2) {
        router.push('/activity/index')
      } else {
          history.go(-1);
      }

    };
  },
});
